export default __webpack_public_path__ + "static/media/gallery27.742c6c44.webp";